import { jsx } from 'react/jsx-runtime';
import { useMoimCommonContext, parseCommonFormat } from '@moim/common';
import { ClipboardWrapper } from '../../components/clipboardWrapper.mjs';
import { Link } from '../../components/link.mjs';
import * as React from 'react';
import { withPlacement } from '../../hoc/withPlacement.mjs';
import { TextComponent } from './component.mjs';

var Texts = function Texts(block) {
  var className = block.className,
    content = block.content,
    color = block.color,
    align = block.align,
    subType_v2 = block.subType_v2,
    actionId = block.actionId,
    href = block.href,
    border = block.border,
    textSets = block.textSets,
    fontWeight = block.fontWeight,
    fontFamily = block.fontFamily,
    letterSpacing = block.letterSpacing,
    _block$copyable = block.copyable,
    copyable = _block$copyable === void 0 ? false : _block$copyable,
    onClick = block.onClick;
  var weight = fontWeight;
  var locale = useMoimCommonContext(function (state) {
    return state.currentLocale;
  });
  var role = actionId ? "button" : undefined;
  var displayContent = React.useMemo(function () {
    if (typeof content === "string") {
      var newText = content;
      var parsedResult = parseCommonFormat(content);
      parsedResult.forEach(function (item) {
        var _a;
        var replaceData = item.fallback;
        switch (item.type) {
          case "text_sets":
            {
              var textSet = textSets === null || textSets === void 0 ? void 0 : textSets[item.value];
              if (textSet) {
                replaceData = (_a = textSet[locale]) === null || _a === void 0 ? void 0 : _a.singular;
              }
              break;
            }
        }
        newText = newText.replace(item.origin, replaceData);
      });
      return jsx(Link, {
        href: href,
        children: newText
      });
    }
    return jsx(Link, {
      href: href,
      children: content
    });
  }, [href, content, locale, textSets]);
  var handleClick = React.useCallback(function (e) {
    if (onClick) {
      onClick(e, Object.assign(Object.assign({}, block), {
        content: typeof content === "string" ? content : ""
      }));
    }
  }, [block, onClick]);
  return jsx(TextComponent, {
    role: role,
    className: className,
    color: color,
    align: align,
    border: border,
    fontWeight: weight,
    fontFamily: fontFamily,
    letterSpacing: letterSpacing,
    onClick: handleClick,
    subType_v2: subType_v2,
    children: jsx(ClipboardWrapper, {
      copyText: typeof content === "string" ? content : "",
      copyable: copyable,
      children: displayContent
    })
  });
};
var index = withPlacement(Texts);

export { index as default };
